define('commons/ajax-filter-form',['jquery', 'commons/loading-mask'], function($, LoadingMask) {

    var AjaxFilterForm = function(form, options) {
        this.form = $(form);

        // Setting the configuration
        this.settings = $.extend({
            paginationLinks: '.paginator',
            container: '.data-container',
            url: null,
            method: 'POST',
            onDataReceived: null,
            autoStart: true
        }, options);

        this.paginator = this.form.find(this.settings.paginationLinks);
        this.paginator.find('.paginator-link').click($.proxy(function(event) {
            this.pageParams = $(event.currentTarget).data('params');
            this.form.submit();
            return false;
        }, this));

        this.dataContainer = this.form.find(this.settings.container);

        // Add a callback function to the submit form method
        this.form.submit($.proxy(function() {
            this.requestForm();
            return false;
        }, this));

        this.form.find(':reset').each($.proxy(function(index, button) {
            $(button).mousedown($.proxy(function() {
                // Reset the form
                this.form.get(0).reset();
                delete this.pageParams;
                // Resets hidden fields since Firefox skips them
                this.form.find('input:hidden').each(function() {
                    if (!$(this).data('no-reset')) {
                        this.value = '';
                    }
                });
                this.form.submit();
            }, this));
        }, this));

        // Date picker
        this.form.find('.date-picker').each($.proxy(function(index, value) {
            var $value = $(value);
            var datePickerOptions = {
                altField: '#' + value.id + '-alt',
                altFormat: 'yy-mm-dd' // ISO_8601
            };
            if (typeof this.settings.maxDate != 'undefined') {
                datePickerOptions.maxDate = this.settings.maxDate;
            }
            if (typeof this.settings.minDate != 'undefined') {
                datePickerOptions.minDate = this.settings.minDate;
            }
            $value.datepicker(datePickerOptions);

            $value.blur($.proxy(function() {
                if (this.val().length === 0) {
                    $('#' + this.attr('id') + '-alt').val('');
                }
            }, $value));
        }, this));

        this.loadingMask = new LoadingMask(this.settings.container, {
            iconPosition: '50% 100px'
        });

        if (this.settings.autoStart) {
            this.form.submit();
        }
        $("button[type='reset']").prop('disabled', false);
        $("button[type='submit']").prop('disabled', false);
    };

    AjaxFilterForm.prototype.requestForm = function() {
        this.loadingMask.show();
        $.ajax({
            type: this.settings.method,
            url: this.settings.url,
            dataType: 'json',
            data: this.form.serialize() + (this.pageParams ? '&' + this.pageParams : ''),
            traditional: true,
            success: $.proxy(function(data) {
                // change pagination
                this._createPagination(data.page);

                // handle data
                if (this.settings.onDataReceived) {
                    this.settings.onDataReceived(data);
                }

                this.loadingMask.hide();
            }, this)
        });
    };

    // Create pagination
    AjaxFilterForm.prototype._createPagination = function(page) {
        this.paginator.each($.proxy(function(index, paginator) {
            var $paginator = $(paginator);
            // build previous link
            var link = $paginator.find('.paginator-link-previous');
            if (page.hasPrevious) {
                link.data('params', page.previousPageParams);
                link.show();
            } else {
                link.hide();
            }
            // build next link
            link = $paginator.find('.paginator-link-next');
            if (page.hasNext) {
                link.data('params', page.nextPageParams);
                link.show();
            } else {
                link.hide();
            }
            // display page number and bind event onclick
            $paginator.find('.page-number').html('page ' + page.page);
        }, this));
    };

    return AjaxFilterForm;
});
